import { render, staticRenderFns } from "./DetailHistory.vue?vue&type=template&id=1d68f92b&"
import script from "./DetailHistory.vue?vue&type=script&lang=js&"
export * from "./DetailHistory.vue?vue&type=script&lang=js&"
import style0 from "./DetailHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports